import environment from "../common/environment";

const appUrl = environment.getAppHost();
const apiUrl = environment.getApiHost();

const routes = {
  app: `${appUrl}`,
  api: `${apiUrl}`,
  accessDenied: `${appUrl}/access-denied`,
  expire: `${appUrl}/expire`,
  expired: `${appUrl}/expired`,
  signout: `${appUrl}/signout`,
  unableToStart: `${appUrl}/unable-to-start`,
};

export default routes;
